import { render, staticRenderFns } from "./cmpOptFormDialog.vue?vue&type=template&id=765850c2&scoped=true&"
import script from "./cmpOptFormDialog.vue?vue&type=script&lang=js&"
export * from "./cmpOptFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765850c2",
  null
  
)

export default component.exports